import { Link, Text } from '@chakra-ui/react';
import { FC, Fragment } from 'react';

interface IChatMessageFormatter {
  message: string;
}

const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|([^\s]{2,40}\.\w{2,3})(?:\s|$)/gi;

export const ChatMessageFormatter: FC<IChatMessageFormatter> = ({ message }) => {
  const parts = message.split(urlRegex);

  return (
    <Text>
      {parts.map((part, index) => {
        if (part?.match(urlRegex)) {
          const href = part.startsWith('http') ? part : `https://${part}`;

          return (
            <Link key={index} href={href} isExternal color="blue.500" textDecoration="underline" mx={0.5}>
              {part}
            </Link>
          );
        }
        return <Fragment key={index}>{part}</Fragment>;
      })}
    </Text>
  );
};
